import {   
  LOGIN_STARTED,
  LOGIN_SUCCESS, 
  LOGIN_FAILURE
} from './actionTypes'

const isLogin = Boolean(window.sessionStorage.getItem('authToken')) || Boolean(window.localStorage.getItem('authToken'))
const userInfo = JSON.parse(window.sessionStorage.getItem('userInfo') as string) || JSON.parse(window.localStorage.getItem('userInfo') as string)

const initState = {
  ...userInfo,
  isLogin,
  isLoading: false
}

export default (state = initState, action: any) => {
  switch (action.type) {
    case LOGIN_STARTED:
      return { ...state, isLoading: true }

    case LOGIN_SUCCESS:
      return { ...state, ...action.data, isLogin: true, isLoading: false }

    case LOGIN_FAILURE:
      return { isLogin: false, isLoading: false }

    default:
      return state
  }
}
